import React, { useEffect, useState } from 'react';
import Review from '../Review/Review';

const Reviews = () => {
    const [reviews,setReviews] =useState([]);

    useEffect( () => {
        fetch('./Reviews.JSON')
        .then(res=>res.json())
        .then(data=>setReviews(data))
    },[])
    return (
        <div>
           <h1 style={{color:'#2a5568'}}>Customer reviews</h1> 
           <div className="container mt-3">
               <div className="row row-cols-1 row-cols-md-3 g-4">
                  {
                      reviews.map(review=><Review
                      key={review.id}
                      review={review}
                      
                      ></Review>)
                  }
               </div>
           </div>
        </div>
    );
};

export default Reviews;